import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import TenantProvider from './TenantProvider';
import { initStorage } from './storage';
import reportWebVitals from './reportWebVitals';

// ─── Tenant boot ──────────────────────────────────────────────────────────────
// Extract the weddingId from the first URL path segment before React mounts,
// so all storage reads/writes throughout the session use the correct Firestore
// collection paths. When no segment is present (root path '/'), initStorage is
// called with null, which triggers the backwards-compat fallback to the
// original top-level 'shared' collection.
const RESERVED_PATHS = new Set(['admin', 'static', 'favicon.ico', 'manifest.json', 'robots.txt']);
const pathSegment = window.location.pathname.split('/').filter(Boolean)[0];
const weddingId = (pathSegment && !RESERVED_PATHS.has(pathSegment)) ? pathSegment : null;
initStorage(weddingId);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <TenantProvider>
      <App />
    </TenantProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
